export var toggleClass = function (props) {
    var selectorHandler = props.selectorHandler, selectorParentElement = props.selectorParentElement, selectorElementToAddClass = props.selectorElementToAddClass, toggleClasss = props.toggleClasss;
    var handlerElement = document.querySelectorAll(selectorHandler);
    if (handlerElement) {
        handlerElement.forEach(function (element) {
            element.addEventListener('click', function () {
                var _a, _b;
                if (selectorParentElement) {
                    var parent_1 = element.closest(selectorParentElement);
                    if (parent_1) {
                        (_a = parent_1.querySelector(selectorElementToAddClass)) === null || _a === void 0 ? void 0 : _a.classList.toggle(toggleClasss);
                    }
                }
                else {
                    (_b = document.querySelector(selectorElementToAddClass)) === null || _b === void 0 ? void 0 : _b.classList.toggle(toggleClasss);
                }
            });
        });
    }
};
